module.exports = __webpack_public_path__ + "images/marketing_site/icons/ico-mail-blue.png";